import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Mark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 96" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="aesmark" x1="0" y1="0" x2="48" y2="96" gradientUnits="userSpaceOnUse">
        <stop stopColor="#8B3A9C" />
        <stop offset="1" stopColor="#2563EB" />
      </linearGradient>
    </defs>
    <path d="M24 4 L44 70 L24 92 L4 70 Z" fill="url(#aesmark)" opacity="0.95" />
    <path d="M24 4 L44 70 L24 92 L4 70 Z" stroke="#0A0A0A" strokeWidth="3" strokeLinejoin="round" />
    <path d="M24 4 L24 92 M4 70 L44 70" stroke="#0A0A0A" strokeWidth="2" opacity="0.55" />
  </svg>
);
